<style>
#precaptcha > div {
  margin: auto;
}
.btn {
  font-size: 1rem;
}
input {
  font-size: 1rem;
  height: 45px;
  border-left: solid 5px #5bd7fc !important;
}
</style>

<script>
import Layout from "../../layouts/auth";
import { authFackMethods, notificationMethods } from "@/state/helpers";
import { mapState } from "vuex";
import appConfig from "@/app.config";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Giriş Yap",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      forgotPasswordToggle: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required: requiredIf(function () {
        return !this.forgotPasswordToggle;
      }),
    },
  },
  computed: {
    ...mapState("authfack", ["loading"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authFackMethods,
    ...notificationMethods,

    tryToLogIn() {
      this.submitted = true;
      this.loadingStatus(true);
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitted = false;
        this.loadingStatus(false);
        return;
      } else {
        this.tryingToLogIn = true;
        this.authError = null;
        this.submitted = false;

        if (this.forgotPasswordToggle) {
          this.forgotPassword({
            email: this.email,
          });
        } else {
          this.login({
            email: this.email,
            password: this.password,
          });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="card-body pt-2">
            <div class="row my-3">
              <div class="col-md-12">
                <img
                  src="@/assets/images/logo-dark.png"
                  width="220"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>

            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
            >
              {{ authError }}
            </b-alert>

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2 mt-3" @submit.prevent="tryToLogIn">
              <b-form-group
                id="username"
                label="Kullanıcı Adı"
                label-for="username"
                class="mb-3"
              >
                <b-form-input
                  id="username"
                  v-model="email"
                  type="text"
                  placeholder="Kullanıcı Adınızı Giriniz"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required"
                    >Kullanıcı adı alanı zorunludur.</span
                  >
                </div>
              </b-form-group>

              <b-form-group
                v-if="!forgotPasswordToggle"
                id="password"
                label="Şifre"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  v-model="password"
                  type="password"
                  placeholder="Şifrenizi Giriniz"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required"
                    >E-Posta alanı zorunludur.</span
                  >
                </div>
              </b-form-group>

              <div class="row" v-if="forgotPasswordToggle">
                <div class="col-md-12">
                  <div class="alert alert-warning">
                    Kayıtlı telefon numaranıza yeni şifreniz gönderilecektir.
                  </div>
                </div>
              </div>

              <div class="row p-2">
                <div class="col-md-12 text-end">
                  <a
                    href="javascript:void(0)"
                    v-if="!forgotPasswordToggle"
                    @click="forgotPasswordToggle = !forgotPasswordToggle"
                    >Şifremi Unuttum</a
                  >
                  <a
                    href="javascript:void(0)"
                    v-else
                    @click="forgotPasswordToggle = !forgotPasswordToggle"
                    >Giriş Yap</a
                  >
                </div>
              </div>

              <div class="mt-3 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  :disabled="loading"
                >
                  <span v-if="loading">
                    <i
                      class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    ></i>
                    Bekleyiniz
                  </span>
                  <span v-else>
                    <template v-if="!forgotPasswordToggle">Giriş Yap</template>
                    <template v-else>SMS Gönder</template>
                  </span>
                </b-button>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>